import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, Send, Loader2, CheckCircle, MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
    } catch { alert("Failed to send message"); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full bg-[#0F0F0F] border border-[#2A2A2A] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] rounded-xl px-4 py-3 text-[#F5F5F5] font-manrope outline-none transition-all";

  return (
    <div className="min-h-screen bg-[#050505] px-6 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-outfit text-4xl font-bold text-[#F5F5F5] mb-2" data-testid="contact-title">Contact Us</h1>
        <p className="text-[#A0A0A0] font-manrope mb-10">We're here to help. Reach out anytime.</p>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="bg-[#0F0F0F] border border-[#2A2A2A] rounded-xl p-6">
              <div className="flex items-center gap-3 mb-3"><Mail className="w-5 h-5 text-[#D4AF37]" /><h3 className="font-outfit font-semibold text-[#F5F5F5]">Email Support</h3></div>
              <p className="text-[#A0A0A0] font-manrope text-sm">support@prestigius-wireless.org</p>
              <p className="text-[#A0A0A0]/60 font-manrope text-xs mt-1">Response within 24 hours</p>
            </div>
            <div className="bg-[#0F0F0F] border border-[#2A2A2A] rounded-xl p-6">
              <div className="flex items-center gap-3 mb-3"><MessageCircle className="w-5 h-5 text-[#D4AF37]" /><h3 className="font-outfit font-semibold text-[#F5F5F5]">Ghost AI Assistant</h3></div>
              <p className="text-[#A0A0A0] font-manrope text-sm">Click the Ghost icon in the bottom-right corner for instant help with plans, billing, and account questions.</p>
            </div>
          </div>

          <div className="bg-[#0F0F0F] border border-[#2A2A2A] rounded-2xl p-6">
            {sent ? (
              <div className="text-center py-8"><CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-4" /><h3 className="font-outfit text-xl font-semibold text-[#F5F5F5] mb-2">Message Sent!</h3><p className="text-[#A0A0A0] font-manrope text-sm">We'll get back to you shortly.</p></div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
                <h3 className="font-outfit text-lg font-semibold text-[#F5F5F5] mb-2">Send a Message</h3>
                <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} className={inputCls} placeholder="Your Name" required data-testid="contact-name" />
                <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} className={inputCls} placeholder="Your Email" required data-testid="contact-email" />
                <textarea value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} className={`${inputCls} h-32 resize-none`} placeholder="How can we help?" required data-testid="contact-message" />
                <button type="submit" disabled={loading} className="w-full bg-[#D4AF37] hover:bg-[#F0C541] text-black py-3 rounded-full font-semibold flex items-center justify-center gap-2 transition-all disabled:opacity-50" data-testid="contact-submit">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send Message
                </button>
              </form>
            )}
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-[#2A2A2A]"><Link to="/" className="text-[#D4AF37] font-manrope hover:underline">&larr; Back to Home</Link></div>
      </div>
    </div>
  );
}
